import React from 'react';
import { TermsTableContainer, TermsTableRow, TermsTableCell } from './TermsAndConditions.styles';
import { DataInfo } from './constants/data';

interface TermsListProps {
  items: DataInfo[];
}
const TermsTable: React.FC<TermsListProps> = ({ items }) => {
  return (
    <TermsTableContainer>
      {items.map(({ label, text, boldText }, index) => (
        <TermsTableRow key={index}>
          <TermsTableCell bold={boldText}>{label}</TermsTableCell>
          <TermsTableCell bold={boldText}>{text}</TermsTableCell>
        </TermsTableRow>
      ))}
    </TermsTableContainer>
  );
};

export default TermsTable;
